

export function getSettingMenuItems(props) {

    const { bundle, hasMyChart, epicEHRDown, isProxyUser, currentPharmacyUser, isMyChartInActive } = props;
    const pathname = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
    const isPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
    const isMyBSWHealth = bundle === "mybswhealth" && !isPharmacy;
    const notPharmacyProxy = isMyBSWHealth || isPharmacy && !currentPharmacyUser;
    const isMyChartProxyUser = isProxyUser;
    return {
        icon: 'icon-settings',
        show: true,
        navHead: {
            label: 'Settings',
            url: null
        },
        navItems: [
            {
                label: 'Notifications',
                show: notPharmacyProxy,
                url: '/notifications',
                altUrls: ['/preferencesettings'],
                subMenuItems: null
            },
            {
                label: 'Preferences',
                show: notPharmacyProxy && hasMyChart,
                url: '/preferences',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Linked Accounts and Devices',
                show: notPharmacyProxy && !isMyChartProxyUser, //Temporarilty hiding for proxies until data tile can be fixed
                url: '/linkedaccounts',
                altUrls: ['/linkeddevices'],
                subMenuItems: null
            },
            {
                label: 'Login Settings',
                show: notPharmacyProxy && !isMyChartProxyUser,
                url: '/loginsettings',
                subMenuItems: null
            },
            {
                label: 'Grant/Access Family Accounts',
                show: notPharmacyProxy && !isMyChartProxyUser,
                url: '/proxymanagement',
                altUrls: ['/proxyrequestdob', "/proxyrequest", "/grantaccessproxy", "/acceptproxy"],
                subMenuItems: null
            },
            {
                label: "Need Help?",
                show: true,
                url: '/faq',
                subMenuItems: null
            }
            //,
            //{
            //    label: 'What\'s New',
            //    show: true,
            //    url: '/whatsnew',
            //    subMenuItems: null
            //}
        ]
    };
}